import {api} from "..";

const endpoint = "/api/attachments";

// Upload file attachment
export const uploadAttachment = async (formData) => {
  const response = await api.post(`${endpoint}/upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
};

// Download file by UUID
export const downloadAttachment = async (uuid) => {
  const response = await api.get(`${endpoint}/download/${uuid}`, {
    responseType: "blob",
  });
  return response;
};

// Download batch files as ZIP
export const downloadBatchAttachments = async (filter) => {
  const response = await api.post(`${endpoint}/download/batch`, filter, {
    responseType: "blob",
  });
  return response;
};

// Get attachment details by UUID
export const getAttachment = async (uuid) => {
  const response = await api.get(`${endpoint}/${uuid}`);
  return response;
};

// Search/filter attachments
export const searchAttachments = async (filter) => {
  const response = await api.post(`${endpoint}/search`, filter);
  return response;
};

// Update attachment metadata
export const updateAttachment = async (uuid, data) => {
  const response = await api.put(`${endpoint}/${uuid}`, data);
  return response;
};

// Delete attachment by UUID
export const deleteAttachment = async (uuid) => {
  const response = await api.delete(`${endpoint}/uuid/${uuid}`);
  return response;
};

// Check if file code exists
export const checkFileCodeExists = async (fileCode, companyId) => {
  const response = await api.get(`${endpoint}/exists/file-code`, {
    params: { fileCode, companyId },
  });
  return response;
};
